import { computed, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CUSTOM_ROUTE_DESKTOP_MAP } from 'src/app/pages/custom-route/components/custom-route-desktop/config/constants';
import { CustomRouteDesktopViewStateService } from 'src/app/pages/custom-route/components/custom-route-desktop/services/custom-route-desktop-view-state.service';
import { CUSTOM_ROUTE_MOBILE_MAP } from 'src/app/pages/custom-route/components/custom-route-mobile/config/constants';
import { CustomRouteMobileViewsStateService } from 'src/app/pages/custom-route/components/custom-route-mobile/services/custom-route-mobile-views-state.service';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';

@Injectable({ providedIn: 'root' })

export class ShowComponentService {
    private _customRouteMobileViewsStateService = inject(CustomRouteMobileViewsStateService);
    private _sessionStorageService = inject(SessionStorageService);
    private _breakpoints = inject(BreakpointsService);
    private _customRouteService: CustomRouteService = inject(CustomRouteService);
    private _customRouteDesktopViewStateService = inject(CustomRouteDesktopViewStateService);
    private _router = inject(Router);

    private customRouteData = computed<boolean>(() => this._customRouteService.customRouteData()?.dailyRoutes?.length > 0);
    
    private guardExistCustomRouteData = () => {
        return this.customRouteData()
            ? null
            : { 
                is_successful: false, 
                reason: 'No hay ruta generada' 
            };
    };

    private guardInCustomRouteView = () => {
        return this._router.url.includes('custom-route')
            ? null
            : { 
                is_successful: false, 
                reason: 'No estás en la vista de la ruta' 
            };
    };

    private guardIsMobile = () => {
        return this._breakpoints.isMobile()
            ? null
            : { 
                is_successful: false, 
                reason: 'En modo escritorio siempre está disponible la vista' 
            };
    };

    private runWithGuards(guards: Array<() => any>, action: () => void) {
        for (const g of guards) {
            const res = g();
            if (res) 
                return res;
        }
        action();
        return { 
            is_successful: true 
        };
    }

    public showTimelineComponent() {
        return this.runWithGuards(
            [
                this.guardExistCustomRouteData, 
                this.guardInCustomRouteView, 
                this.guardIsMobile
            ],
            () => {
                this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.planner);
                this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.planner)
            }
        );
    }

    public showMapComponent() {
        return this.runWithGuards(
            [
                this.guardExistCustomRouteData, 
                this.guardInCustomRouteView, 
                this.guardIsMobile
            ],
            () => {
                this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.map);
                this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.map)
            }        
        );
    }

    public showSendRouteComponent() {
        return this.runWithGuards(
            [
                this.guardExistCustomRouteData, 
                this.guardInCustomRouteView
            ],
            () => {
                if (this._breakpoints.isMobile()){
                    this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.more);
                    this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.more);
                    return;
                }
                this._customRouteDesktopViewStateService.desktopViewsState.set(CUSTOM_ROUTE_DESKTOP_MAP.more);
                this._sessionStorageService.setItem('customRouteDesktopViewsState', CUSTOM_ROUTE_DESKTOP_MAP.more);
            }        
        );
    }
    
}